import {createSelector} from '@reduxjs/toolkit'

import {RootState} from './interfaces'

export const orderTotalSelector = (state: RootState) => state.orderTotal

/** 결제 금액 selector */
export const orderAmountInfoSelector = createSelector(
    orderTotalSelector,
    ({amount, deliveryFeeAmount, discountAmount, safetyPurchaseAmount, cupDeposit, deposit, escrow}) => {
        const disposableCupDepositAmount = cupDeposit?.disposable ?? 0
        const reusableCupDepositAmount = cupDeposit?.reusable ?? 0
        const cupDepositAmount = disposableCupDepositAmount + reusableCupDepositAmount
        const branchDepositAmount = deposit?.amount ?? 0

        const escrowTotalAmount = escrow ? escrow.productAmount + escrow.deliveryFeeAmount : 0
        const safetyPurchaseCommissionAmount = escrow
            ? escrow.productAmount + escrow.deliveryFeeAmount
            : safetyPurchaseAmount

        const orderAmount =
            amount +
            deliveryFeeAmount -
            discountAmount +
            safetyPurchaseCommissionAmount +
            cupDepositAmount +
            branchDepositAmount

        return {
            amount,
            deliveryFeeAmount,
            discountAmount,
            safetyPurchaseAmount: safetyPurchaseCommissionAmount,
            escrow: {
                totalAmount: escrowTotalAmount,
                productAmount: escrow?.productAmount ?? 0,
                deliveryFeeAmount: escrow?.deliveryFeeAmount ?? 0,
            },
            disposableCupDepositAmount,
            reusableCupDepositAmount,
            cupDepositAmount: disposableCupDepositAmount + reusableCupDepositAmount,
            branchDepositAmount: deposit?.amount ?? null,
            branchDepositType: deposit?.type ?? null,
            /** 주문 금액 */
            orderAmount,
        }
    },
)
